// extracted by mini-css-extract-plugin
export default {"body":"CAMUpload_body__CpE6j"};